import _ from 'lodash'
import { SettingPersistRow } from '../lib/setting'
import { sqlQuery, sqlRun } from "./ldb"
import { err, ok, Result } from 'neverthrow'
import { FusionError, serializeFusionError } from '@fusion-advantage/backcompat'
import { selectAllText } from './LdbBrowser'

export const selectLdbSettings = async (): Promise<Result<SettingPersistRow[], FusionError>> => {
	let r = await sqlQuery<SettingPersistRow>(
		`
			select id, value
			  from setting
		`,
	)
	if(r.isErr()) {
		return err(serializeFusionError('selectLdbSettings', r.error))
	}
	return ok(r.value)
}

export const selectAllSettingText = async (): Promise<string> => {
	return selectAllText('setting', ['id', 'value'])
}

export const updateLdbSettings = async (rows: SettingPersistRow[]): Promise<Result<void, FusionError>> => {
	for(let {id, value} of rows) {
		let r = await sqlRun(
			`
				insert into setting (id, value)
				values (?, ?)
				on conflict do update set value = ?
			`,
			[
				id, value, value,
			],
		)
		if(r.isErr()) {
			return err(serializeFusionError('updateLdbSettings', r.error))
		}
	}
	return ok()
}
